export interface AuthFlowState {
  isAuthenticated: boolean;
  isEmailVerified: boolean;
  isMfaEnrolled: boolean;
  isMfaChallengeRequired: boolean;
}

export function getNextAuthRoute(state: AuthFlowState) {
  if (state.isMfaChallengeRequired) {
    return '/mfa-challenge';
  }

  if (!state.isAuthenticated) {
    return '/login';
  }

  if (!state.isEmailVerified) {
    return '/verify-email';
  }

  if (!state.isMfaEnrolled) {
    return '/mfa-setup';
  }

  return '/dashboard';
}

export function hasFullAppAccess(state: AuthFlowState) {
  return (
    state.isAuthenticated
    && state.isEmailVerified
    && state.isMfaEnrolled
    && !state.isMfaChallengeRequired
  );
}
